export async function getDeviceInfo() {
    const nav = navigator;

    //let brand = 'unknown';
    let model = 'unknown';
    let platform = nav.platform || 'unknown';
    let osVersion = 'unknown';

    try {
        if (nav.userAgentData) {
            const ua = await nav.userAgentData.getHighEntropyValues([
                "platform",
                "platformVersion",
                "model"
            ]);

            model = ua.model || model;
            platform = ua.platform || platform;
            osVersion = ua.platformVersion || osVersion;
        }
    } catch (err) {
        // Log the error for debugging purposes, but continue with fallback logic.
        console.error("Error in getHighEntropyValues:", err);
    }

    const uaString = nav.userAgent.toLowerCase();

    if (uaString.includes("iphone")) {
        model = "iPhone";
    }
    if (uaString.includes("ipad")) {
        model = "iPad";
    }
    if (uaString.includes("android") && model === 'unknown') {
        model = "Android device";
    }

    return { model, platform, osVersion };
}
